import { Action, ACTION_TYPE, ERROR_CODE } from '@abiglobalhealth/go-types'

import { actionsRequest } from '@/api/utils'

export const setChoice = async <T extends Action<ACTION_TYPE.SET_CHOICE>>({ uniqueId, choice }: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload: {
      uniqueId,
      choice
    },
    type: ACTION_TYPE.SET_CHOICE
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  const { choice: choiceSet } = body.data

  return {
    choice: choiceSet
  }
}
